<template>
  <section class="flex align-middle justify-center sm:py-40">
    <div class="flex flex-col">
      <a class="link--primary mb-16" :href="redirectTo">
        <div class="inline-block md:pl-0 mt-4"><BackIcon /></div>
        <p class="inline-block ml-8">Pricing</p>
      </a>
      <Card class="w-full max-w-448 p-24">
        <form @submit.prevent="submit">
          <h1 class="text-h1 mb-16">Check your eligibility</h1>
          <fieldset>
            <legend class="pb-16 text-body text-grey-body">
              If your company is found, Sittercity Premium may be included in your corporate benefits
            </legend>
            <CorporateClientComboBox allow-empty-results @selected-client="selectedClient" />
          </fieldset>
          <Button class="w-full mt-16" variant="primary" value="Continue" size="medium" type="submit" />
        </form>
      </Card>
    </div>
  </section>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import BackIcon from '@/icons/BackIcon.vue';
import { sendSegmentEventWithTimeout } from '@/lib/segment';
import {
  INVALID_EMPLOYER_SOURCES,
  trackInvalidEmployerEnteredWithTimeout,
  type InvalidEmployerFailureReason,
} from '@/lib/tracking/trackInvalidEmployerEntered';
import CorporateClientComboBox from '../../components/CorporateClientComboBox.vue';

export default {
  name: 'CheckEligibility',
  components: {
    Button,
    Card,
    BackIcon,
    CorporateClientComboBox,
  },
  props: {
    redirectTo: { type: String, default: '' },
  },
  data(): any {
    return {
      employerNameInput: '',
      selectedCompanySlug: '',
      selectedBhClientId: '',
      selectionAttempted: false,
    };
  },
  methods: {
    selectedClient({ slug, name, bhClientId, selectionAttempted }) {
      this.employerNameInput = name;
      this.selectedCompanySlug = slug;
      this.selectedBhClientId = bhClientId;
      this.selectionAttempted = selectionAttempted;
    },
    invalidEmployerEnteredProperties(failureReason: InvalidEmployerFailureReason) {
      return {
        employerEntered: this.employerNameInput,
        bhClientId: this.selectedBhClientId,
        failureReason,
        source: INVALID_EMPLOYER_SOURCES.bhBenefitsCheckEligibility,
      };
    },
    validateEmployerEntered(employer: string): boolean {
      return employer?.trim().length > 0;
    },
    async submit() {
      const searchedEmployerProperties = {
        employerSlugEntered: this.selectedCompanySlug,
        employerNameInput: this.employerNameInput,
      };

      if (this.selectedCompanySlug !== '') {
        await sendSegmentEventWithTimeout('CorporateBenefit_SearchedEmployer', searchedEmployerProperties);
        this.$emit('advanceStep', {
          employerNameInput: this.employerNameInput,
          slug: this.selectedCompanySlug,
          bhClientId: this.selectedBhClientId,
        });
        return;
      }

      await sendSegmentEventWithTimeout('CorporateBenefit_SearchedEmployer', searchedEmployerProperties);

      if (this.selectionAttempted) {
        await trackInvalidEmployerEnteredWithTimeout(this.invalidEmployerEnteredProperties('no_benefit_match'));
      } else if (this.validateEmployerEntered(this.employerNameInput)) {
        await trackInvalidEmployerEnteredWithTimeout(this.invalidEmployerEnteredProperties('not_in_list'));
      }

      const url = new URL(window.location.origin + this.redirectTo);
      url.searchParams.append('error', 'company_not_found');
      window.location.href = url.toString();
    },
  },
};
</script>
